<template>
  <div class="d-flex flex-column justify-content-evenly timeline-box">
    <div
      id="timeline-container"
      class="w-100 mt-2 hide-scrollbar"
    >
      <KitUserSelector />
      <div id="timeline-wrapper">
        <img
          class="timeline-control-arrow timeline-control-arrow-left"
          src="@/assets/images/icons/arrow-left.svg"
          alt=""
          @click="arrowClickLeft"
        >
        <img
          class="timeline-control-arrow timeline-control-arrow-right"
          src="@/assets/images/icons/arrow-right.svg"
          alt=""
          @click="arrowClickRight"
        >
        <section
          ref="timeline"
          class="timeline-element-wrapper mb-2 pt-1 pt-md-2 w-100 h-100 hide-scrollbar"
        >

          <div
            v-for="(item, index) in timeline"
            :key="index"
            class="text-center"
          >
            <component
              :is="item.image"
              v-b-tooltip.hover.top="item.hoverText"
              :active="item.isActive"
            />

            <p :class="item.isActive ? 'text-active' : ' '">
              {{ item.computedStatus }}
              <span>
                <feather-icon
                  v-if="item.infoIcon && !item.isActive"
                  class="text-danger"
                  icon="InfoIcon"
                  style="margin-left: 0.4rem"
                />
              </span>
            </p>
          </div>
        </section>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
// TODO: add proper scg
import img0 from './timeline-images/0.vue'
import img1 from './timeline-images/1.vue'
import img2 from './timeline-images/2.vue'
import img3 from './timeline-images/3.vue'
import img4 from './timeline-images/4.vue'
import img5 from './timeline-images/5.vue'
import img6 from './timeline-images/6.vue'
import KitUserSelector from '@/components/KituserSelectorMobile.vue'

export default {
  components: {
    img1,
    img0,
    img2,
    img3,
    img4,
    img5,
    img6,
    KitUserSelector,
  },
  props: {
    questionnaireData: {
      type: Object,
      required: true,
    },
    timeline: {
      type: Array,
      required: true,
    },
  },
  methods: {
    // functions to control the arrow click events for timeline
    arrowClickLeft() {
      this.$refs.timeline.scrollTo({
        left: this.$refs.timeline.scrollLeft - this.$refs.timeline.clientWidth / 2,
        behavior: 'smooth',
      })
    },
    arrowClickRight() {
      this.$refs.timeline.scrollTo({
        left: this.$refs.timeline.scrollLeft + this.$refs.timeline.clientWidth / 2,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style>
.vs__dropdown-toggle {
  border: none;
  height: 80%
}

</style>

<style lang="scss" scoped>
#timeline-wrapper {

  .timeline-control-arrow {
    position: absolute;
    top: 50%;
    transform:translateY(-50%);
    height: 30px;
    z-index: 50;
    &.timeline-control-arrow-left {
      left: 0;
    }

    &.timeline-control-arrow-right {
      right: 0;
    }
  }
  position: relative;
  .timeline-element-wrapper {
    display: grid;
    grid-template-columns: repeat(5, 50%) 75%;
    grid-auto-rows: 100%;

    scroll-snap-type: x mandatory;

    height: 100%;
    width: 100%;
    overflow-x: scroll;

    & > div {
      scroll-snap-align: center;
      width: 100%;
      margin: 0 50%;
    }

    &::before {
      content: " ";
      position: absolute;
      pointer-events: none;

      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: -webkit-linear-gradient(to right, rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%);
        background-image: -moz-linear-gradient(to right, rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%);
        background-image: -o-linear-gradient(to right, rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%);
      background-image:
        linear-gradient(to right, rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%);

      background-image: -ms-linear-gradient(to right, rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 1) 100%);
      }
  }
}

@media only screen and (min-width: 991px) {
  .timeline-control-arrow {
    display: none;
  }
  .timeline-element-wrapper {
    &::before {
      display: none;
    }
    display: flex !important;
    align-items: start;
    justify-content: start;
    height: 100%;
    width: 100%;
    overflow-x: hidden;

    & > div {
      margin: unset !important;
    }

  }
}

.timeline-box {

  section {
    // causes the some timeline elements to be hidden
    /* justify-content: space-evenly; */
    div {
      div {
        height: 4.375rem;
        width: 4.375rem;
        border-radius: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        img {
          height: 2.125rem;
          width: 2.125rem;
        }
      }

      p {
        text-align: center;
        font-size: var(--dashboard-default-font-size);
        color: #c6c6c6;
        opacity: 1;
        margin-top: 1.5rem;
        padding: 0 1rem;
        &.text-active {
        color: #0A6ECA !important;
        }
      }
    }
  }
}

#timeline-container {
    background: #fff;
    border-radius: 10px;
}

#timeline-container::-webkit-scrollbar {
  display: none;
}

#timeline-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
   display: none;
 }

 .hide-scrollbar {
   -ms-overflow-style: none;  /* IE and Edge */
   scrollbar-width: none;
 }

@media only screen and (max-width: 991px) {
  #timeline-container > div {
    margin: 0 1rem 0 1rem;
  }
  .timeline-element-wrapper {
    & > div:last-child {
      padding-right: 7em;
    }
  }
}

</style>
